module.exports = __webpack_public_path__ + "static/media/theboys_bg.922724fc.png";